import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

const LoadingWorkSpace = () => {
  return (
    <Box style={{ flexBasis: '100%' }}>
      <div>
        <Box gap="s8" flexDirection="row" alignItems="center">
          <Skeleton width="s200" height="s24" /> <Skeleton width="s120" height="s16" />
        </Box>
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="flexStart"
          flexWrap="wrap"
          paddingTop="s16"
          paddingBottom="s16"
          gap="s16"
        >
          {Array(3).fill(
            <Box
              borderRadius={{ all: 'abs008' }}
              border={{
                all: {
                  color: 'grey400',
                  width: 's1',
                  style: 'solid',
                },
              }}
              style={{ flexBasis: '45%' }}
              padding="s16"
              gap="s48"
              flexWrap="wrap"
            >
              <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
                <Box flexDirection="column" gap="s8">
                  <Skeleton width="s140" height="s12" />
                  <Skeleton width="s120" height="s8" />
                </Box>
              </Box>
              <Box alignItems="flexStart" gap="s8" flexDirection="row">
                <Skeleton width="s32" height="s12" /> <Skeleton width="s8" height="s12" />
                <Skeleton width="s32" height="s12" />
              </Box>
            </Box>
          )}
        </Box>
      </div>
    </Box>
  )
}

export default observer(LoadingWorkSpace)
